import { useEffect, useState } from 'react';
import { useLocation } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

import { NavigationButton } from 'components';
import { Filter, NavegationDashboard } from './components';

import { Wrapper } from './styles';

import pages from './mock';
import { GraphicDataRequest } from './@types/graphic';
import { CardDataRequest } from './@types/cards';
import { getAllGraphics } from 'services/graphicsRequest';
import { DashboardRequestData } from './@types/dashboard';
import { useOptions } from 'hooks/useOptions';
import { MountObjectFilter } from 'contexts/@types/Filter';
import { useFilter } from 'hooks/useFilter';
import { captureMonitoringEvent } from 'services/monitoring';

export function Dashboard() {
  const location = useLocation();

  const { i18n } = useTranslation();
  const { update } = useOptions();
  const { clearFilterData, mountObjectFilter } = useFilter();

  const [loading, setLoading] = useState(false);
  const [filters, setFilters] = useState<MountObjectFilter>({});

  const [cardsData, setCardsData] = useState<CardDataRequest[]>([]);
  const [graphicsData, setGraphicsData] = useState<GraphicDataRequest[]>([]);

  const [hiddenCardsData, setHiddenCardsData] = useState<CardDataRequest[]>([]);
  const [hiddenGraphicsData, setHiddenGraphicsData] = useState<GraphicDataRequest[]>([]);

  const [favoriteCardsData, setFavoriteCardsData] = useState<CardDataRequest[]>([]);
  const [favoriteGraphicsData, setFavoriteGraphicsData] = useState<GraphicDataRequest[]>([]);

  function separateHiddenCards(data: CardDataRequest[]) {
    const hiddenCardsStorage: CardDataRequest[] = JSON.parse(localStorage.getItem('hiddenCards') || '[]');

    if (hiddenCardsStorage.length <= 0) {
      return { cards: data, hiddenCards: [] };
    }

    let cards = data;
    const hiddenCards: CardDataRequest[] = [];

    hiddenCardsStorage.forEach(hiddenCard => {
      cards = cards.filter(card => card.id !== hiddenCard.id);
    });

    hiddenCardsStorage.forEach(hiddenCard => {
      const aux = data.filter(card => card.id === hiddenCard.id)[0];
      if (aux) {
        hiddenCards.push(aux);
      }
    });

    return { cards, hiddenCards };
  }

  function separateHiddenGraphics(data: GraphicDataRequest[]) {
    const hiddenGraphicsStorage: GraphicDataRequest[] = JSON.parse(localStorage.getItem('hiddenGraphics') || '[]');

    if (hiddenGraphicsStorage.length <= 0) {
      return { graphics: data, hiddenGraphics: [] }
    }

    let graphics = data;
    const hiddenGraphics: GraphicDataRequest[] = [];

    hiddenGraphicsStorage.forEach(hiddenGraphic => {
      graphics = graphics.filter(graphic => graphic.title !== hiddenGraphic.title);
    });

    hiddenGraphicsStorage.forEach(hiddenGraphic => {
      const aux = data.filter(graphic => graphic.title === hiddenGraphic.title)[0];
      if (aux) {
        hiddenGraphics.push(aux);
      }
    });

    return { graphics, hiddenGraphics };
  }

  function getFavoriteCardsAndGraphics(data: DashboardRequestData) {
    const favoriteCardsStorage: CardDataRequest[] = JSON.parse(localStorage.getItem('favoriteCards') || '[]');
    const favoriteGraphicsStorage: GraphicDataRequest[] = JSON.parse(localStorage.getItem('favoriteGraphics') || '[]');

    const favoriteCards: CardDataRequest[] = [];
    const favoriteGraphics: GraphicDataRequest[] = [];

    favoriteCardsStorage.forEach((favoriteCard) => {
      const aux = data.cards.find(card => card.id === favoriteCard.id);
      if (aux) {
        favoriteCards.push(aux);
      }
    });

    favoriteGraphicsStorage.forEach((favoriteGraphic) => {
      const aux = data.graphics.find(graphic => graphic.title === favoriteGraphic.title);
      if (aux) {
        favoriteGraphics.push(aux);
      }
    });

    return { favoriteCards, favoriteGraphics };
  }

  async function getAllGraphicsData(filter?: MountObjectFilter) {
    setLoading(true);

    const { data } = await getAllGraphics<DashboardRequestData>(filter, i18n.language);

    const { cards, hiddenCards } = separateHiddenCards(data.cards);
    setCardsData(cards);
    setHiddenCardsData(hiddenCards);

    const { graphics, hiddenGraphics } = separateHiddenGraphics(data.graphics);
    setGraphicsData(graphics);
    setHiddenGraphicsData(hiddenGraphics);

    const { favoriteCards, favoriteGraphics } = getFavoriteCardsAndGraphics(data);
    setFavoriteCardsData(favoriteCards);
    setFavoriteGraphicsData(favoriteGraphics);

    setLoading(false);
  }

  const handleApplyFilter = async () => {
    const filterMount = mountObjectFilter();
    await getAllGraphicsData(filterMount);
    setFilters(filterMount);
    if (Object.keys(filterMount).length > 0) {
      void captureMonitoringEvent({ tipo_evento: 'filtro_dashboard_aplicado' });
    }
  };

  useEffect(() => {
    void captureMonitoringEvent({ tipo_evento: 'dashboard_acessada' });
  }, []);

  useEffect(() => {
    clearFilterData();
    getAllGraphicsData(filters);
  }, [update]);

  return (
    <Wrapper>
      <Filter applyFilter={handleApplyFilter} />
      <main className="mainDashboard col-md-12 col-sm-1">
        <NavegationDashboard />
        {pages.map(page => {
          if (location.pathname === page.path) {
            const Element = page.element;

            return (
              <Element
                key={`${page.path}-${page.id}`}
                loadingGraphics={loading}
                cardsData={cardsData}
                graphicsData={graphicsData}
                hiddenCardsData={hiddenCardsData}
                hiddenGraphicsData={hiddenGraphicsData}
                favoriteCardsData={favoriteCardsData}
                favoriteGraphicsData={favoriteGraphicsData}
              />
            );
          }
        })}
      </main>
      <NavigationButton isDashboard />
    </Wrapper>
  );
}
